import React from 'react'
import styled from 'styled-components'
import { styleTheme } from '../../style/theme'
import { addDays } from 'date-fns'

import { BridalFairsProps } from './BridalFairs.types'
import { Slider } from './components/Slider'
import { useConfig } from '../../routes'
import { usePickupBridalFairParticularDetails } from './hooks/usePickupedBridalFairParticularDetails'
import { useParams } from 'react-router-dom'
import { useJpHolidays } from '../../hooks/useJpHolidays'

type ConfigType = {
  primaryColor: string
}

export const PickupParticularFairs: React.FC = () => {
  const config = useConfig() as ConfigType
  return <StyledPage primaryColor={config.primaryColor} />
}

const Page: React.FC<BridalFairsProps> = ({ className, primaryColor }) => {
  const { bridalFairPageKey } = useParams() as { bridalFairPageKey: string }
  const { pickupParticularFairs } = usePickupBridalFairParticularDetails(bridalFairPageKey, {
    per: 6,
    filter: { startDate: addDays(new Date(), 1), endDate: addDays(new Date(), 15) },
  })
  const holidays = useJpHolidays(addDays(new Date(), 1), addDays(new Date(), 90))

  return (
    <div className={className}>
      <div className="slider">
        <Slider
          pickupParticularFairs={pickupParticularFairs}
          primaryColor={primaryColor}
          bridalFairPageKey={bridalFairPageKey}
          holidays={holidays}
        />
      </div>
    </div>
  )
}

const StyledPage = styled(Page)`
  max-width: 768px;
  margin: 0 auto;
  background: transparent;
  color: ${styleTheme.colors.black};
`
